<template>
  <div class="wrapper">
    <CRow>
      <CCol>
        <div class="card">
          <div class="card-body">
            <CRow>
              <CCol lg="4">
                <h5>{{ currentDate() }}</h5>
                <h2>{{ showTime }}</h2>
              </CCol>
              <CCol lg="8" class="mt-3">
                <CButton class="mt-2" color="info" @click="openShow">Scan QR Code</CButton>
                <CButton class="mt-2 ml-2" color="secondary" @click="refreshData">Refresh</CButton>
              </CCol>
            </CRow>
          </div>
        </div>
      </CCol>
    </CRow>

    <CRow>
      <CCol>
        <div class="card">
          <div class="card-body">
            <h3>iKids Report</h3>
            <hr>
            <div class="table-container">
              <table class="table_ikid_report">
                <thead>
                  <tr>
                    <th v-for="item in fieldsClass" :key="item.title">{{ item.title }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="i in datas.data" :key="i.id">
                    <td>{{ i.name }}</td>
                    <td>{{ i.count_check_in }}</td>
                    <td>{{ i.count_queued }}</td>
                    <td>{{ i.count_check_out }}</td>
                    <td>{{ i.count2_check_in }}</td>
                    <td>{{ i.count2_queued }}</td>
                    <td>{{ i.count2_check_out }}</td>
                  </tr>
                  <tr>
                    <th>Total</th>
                    <th>{{ total_check_in }}</th>
                    <th>{{ total_queued }}</th>
                    <th>{{ total_check_out }}</th>
                    <th>{{ total2_check_in }}</th>
                    <th>{{ total2_queued }}</th>
                    <th>{{ total2_check_out }}</th>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </CCol>
    </CRow>

    <CRow>
      <CCol>
        <div class="card">
          <div class="card-body">
            <Datatable
              :items="items"
              :listclass="listclass"
              :fields="fields"
              :meta="meta"
              @per_page="handlePerPage"
              @pagination="handlePagination"
              @search="handleSearch"
              @sort="handleSort"
              @is_active="handleIsActive"
              @status_filter="handleStatus"
              @class_filter="handleClassFilter"
              :btn_show="true"
              :btn_edit="true"
              :btn_deactivate="true"
              :btn_reactivate="false"
              :btn_delete="false"
              :is_uuid="true"
              @checkin="handleCheckin"
              @present="handlePresent"
              @checkout="handleCheckOut"
              @forceCheckout="handleForceCheckOut"
              @cancelStatus="handleCancelStatus"
              @forceCancelStatus="handleForceCancelStatus"
              @reprint="handleReprint"
            />
          </div>
        </div>
      </CCol>
    </CRow>

    <ikidmodal_checkin></ikidmodal_checkin>
    <alertmodal></alertmodal>
  </div>
</template>

<script>
import Datatable from '@/components/datatables_ikid_check.vue'
import ikidmodal_checkin from './ikidsmodal_checkin.vue'
import alertmodal from '@/views/alert/modal.vue'

import ikid from '@/services/ikid'
import EventBus from '@/eventBus'
import axios from 'axios'
import moment from 'moment'

export default {
  name: 'iKidsCheckManual',
  components: { Datatable, ikidmodal_checkin, alertmodal },
  data() {
    return {
      form: {
        ikid_id: '',
        status: '',
        from: 'portal',
      },
      showMilitary: false,
      showTime: '',
      now: new Date(),
      datas: { data: [] },
      listclass: [],
      items: [],
      fields: [
        { key: 'name', sortable: false },
        { key: 'profilepic', sortable: false },
        { key: 'class_name', sortable: false },
        { key: 'dob', sortable: false },
        { key: 'checkin_status', label: 'Status', sortable: false },
        { key: 'action', label: 'Action', sortable: false },
      ],
      fieldsClass: [
        { title: 'Class', sortable: false },
        { title: 'In Service 1', sortable: false },
        { title: 'Queued Service 1', sortable: false },
        { title: 'Out Service 1', sortable: false },
        { title: 'In Service 2', sortable: false },
        { title: 'Queued Service 2', sortable: false },
        { title: 'Out Service 2', sortable: false }
      ],
      meta: {
        total: 0,
        current_page: 1,
        per_page: 10,
        from: 0,
        to: 0,
        is_active: 1,
        checkin_status: 0,
        ikid_class_name: 0,
        kid_class_id: 0,
      },
      current_page: 1,
      per_page: 10,
      search: '',
      sortBy: 'name',
      sortByDesc: false,
      is_active: 1,
      checkin_status: 0,
      ikid_class_name: 0,
      kid_class_id: 0,
      refreshTimer: null,
      refreshQueued: false,
      refreshInFlight: false,
      refreshLastRunAt: 0,
      refreshIntervalMs: 2500,
      heartbeatIntervalMs: 5000,
      heartbeatTimer: null,
      tableUpdateHandler: null,
      lastEventId: null,
      mode: '',
      name: '',
      id: '',
      class: '',
      check_time: '',
      barcode: '',
    }
  },
  async mounted() {
    this.showTheTime()
    await this.refreshData()

    this.tableUpdateHandler = (data) => {
      if (data) {
        this.refreshData()
      }
    }
    EventBus.$on('TABLE_UPDATE_IKIDS_CHECK', this.tableUpdateHandler)
    this.heartbeatTimer = setInterval(() => {
      this.queueRealtimeRefresh()
    }, this.heartbeatIntervalMs)
  },
  beforeDestroy() {
    if (this.refreshTimer) {
      clearTimeout(this.refreshTimer)
      this.refreshTimer = null
    }
    if (this.heartbeatTimer) {
      clearInterval(this.heartbeatTimer)
      this.heartbeatTimer = null
    }
    if (this.tableUpdateHandler) {
      EventBus.$off('TABLE_UPDATE_IKIDS_CHECK', this.tableUpdateHandler)
      this.tableUpdateHandler = null
    }
  },
  computed: {
    total_check_in() {
      return this.datas.data.reduce((total, item) => total + Number(item.count_check_in), 0)
    },
    total_queued() {
      return this.datas.data.reduce((total, item) => total + Number(item.count_queued), 0)
    },
    total_check_out() {
      return this.datas.data.reduce((total, item) => total + Number(item.count_check_out), 0)
    },
    total2_check_in() {
      return this.datas.data.reduce((total, item) => total + Number(item.count2_check_in), 0)
    },
    total2_queued() {
      return this.datas.data.reduce((total, item) => total + Number(item.count2_queued), 0)
    },
    total2_check_out() {
      return this.datas.data.reduce((total, item) => total + Number(item.count2_check_out), 0)
    }
  },
  methods: {
    currentDate() {
      const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
      const current = new Date()
      return current.getDate() + ' ' + months[current.getMonth()] + ' ' + current.getFullYear()
    },
    showTheHours(theHour) {
      if (this.showMilitary || (theHour > 0 && theHour < 13)) {
        if (theHour === '') theHour = 12
        return theHour
      }
      if (theHour === 0) return 12
      return theHour
    },
    showZeroFilled(inValue) {
      if (inValue > 9) return '' + inValue
      return '0' + inValue
    },
    showAmPm() {
      if (this.showMilitary) return ''
      if (this.now.getHours() < 12) return ' AM'
      return ' PM'
    },
    showTheTime() {
      this.now = new Date()
      this.showTime = this.showTheHours(this.now.getHours()) + ':' + this.showZeroFilled(this.now.getMinutes()) + ':' + this.showZeroFilled(this.now.getSeconds()) + this.showAmPm()
      setTimeout(this.showTheTime, 1000)
    },
    openShow() {
      let routeData = this.$router.resolve({ path: '/ikids/kids-scan' })
      window.open(routeData.href, '_blank')
    },
    openCheckin(uuid) {
      var params = {
        title: 'Check In',
        mode: 'detail',
        data: uuid
      }
      EventBus.$emit('OPEN_MODAL_IKID_CHECKIN', params)
    },
    openPresent(uuid) {
      if (confirm('Do you really want to change?')) {
        this.form.ikid_id = uuid
        this.form.status = 2
        ikid.changeStatusKid(this.form)
          .then(() => {
            this.queueRealtimeRefresh()
          }).catch((err) => {
            var params = { title: 'Error', mode: 'danger', data: err.response.data.message }
            EventBus.$emit('OPEN_MODAL_ALERT', params)
          })
      }
    },
    openCheckOut(uuid) {
      if (confirm('Do you really want to change?')) {
        this.form.ikid_id = uuid
        this.form.status = 4
        ikid.changeStatusKid(this.form)
          .then(() => {
            this.queueRealtimeRefresh()
          }).catch((err) => {
            var params = { title: 'Error', mode: 'danger', data: err.response.data.message }
            EventBus.$emit('OPEN_MODAL_ALERT', params)
          })
      }
    },
    openForceCheckOut(uuid) {
      if (confirm('Do you really want to change?')) {
        this.form.ikid_id = uuid
        this.form.status = 3
        ikid.changeStatusKid(this.form)
          .then(() => {
            setTimeout(() => {
              this.form.ikid_id = uuid
              this.form.status = 4
              ikid.changeStatusKid(this.form)
                .then(() => {
                  this.queueRealtimeRefresh()
                }).catch((err) => {
                  var params = { title: 'Error', mode: 'danger', data: err.response.data.message }
                  EventBus.$emit('OPEN_MODAL_ALERT', params)
                })
            }, 1000)
          }).catch((err) => {
            var params = { title: 'Error', mode: 'danger', data: err.response.data.message }
            EventBus.$emit('OPEN_MODAL_ALERT', params)
          })
      }
    },
    openCancelStatus(uuid, stat) {
      if (confirm('Do you really want to change?')) {
        this.form.ikid_id = uuid
        this.form.status = stat
        ikid.cancelStatusKid(this.form)
          .then(() => {
            this.queueRealtimeRefresh()
          }).catch((err) => {
            var params = { title: 'Error', mode: 'danger', data: err.response.data.message }
            EventBus.$emit('OPEN_MODAL_ALERT', params)
          })
      }
    },
    openForceCancelStatus(uuid, stat) {
      if (confirm('Do you really want to change?')) {
        this.form.ikid_id = uuid
        this.form.status = stat
        ikid.cancelStatusKid(this.form)
          .then(() => {
            setTimeout(() => {
              this.form.ikid_id = uuid
              this.form.status = stat - 1
              ikid.cancelStatusKid(this.form)
                .then(() => {
                  this.queueRealtimeRefresh()
                }).catch((err) => {
                  var params = { title: 'Error', mode: 'danger', data: err.response.data.message }
                  EventBus.$emit('OPEN_MODAL_ALERT', params)
                })
            }, 1000)
          }).catch((err) => {
            var params = { title: 'Error', mode: 'danger', data: err.response.data.message }
            EventBus.$emit('OPEN_MODAL_ALERT', params)
          })
      }
    },
    async reprint(uuid) {
      this.form.ikid_id = uuid
      this.mode = 'reprint'

      await ikid.getIkidbyID(uuid)
        .then(res => {
          this.name = '<h4>' + res.data.firstname + ' ' + res.data.lastname + '</h4>'
          this.id = res.data.barcode
          this.class = res.data.ikid_class.name
          this.check_time = moment(res.data.checkin_status.log_time).format('DD/MM/YYYY HH:mm:ss')
          this.barcode = res.data.barcode
          this.connectToPrinter(res.data.firstname, res.data.lastname, res.data.ikid_class.name, res.data.barcode)
        }).catch((err) => {
          var params = { title: 'Error', mode: 'danger', data: err.response.data.message }
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        })
    },
    async connectToPrinter(firstname, lastname, class_id, barcode) {
      const check_time = moment().format('DD/MM/YYYY HH:mm:ss')

      try {
        await axios.post('http://localhost:3000/print', {
          firstname: firstname,
          lastname: lastname,
          class_id: class_id,
          check_time: check_time,
          barcode: barcode
        },
        {
          timeout: 5000,
        })
      } catch (error) {
        console.log('Error connecting to printer:', error)
        console.log('Barcode:', barcode)
      }
    },
    async refreshData(options = {}) {
      const useEventGuard = options.useEventGuard !== false
      const foundClass = this.listclass.find(item => item.name === this.ikid_class_name)
      this.kid_class_id = foundClass ? foundClass.id : 0

      const payload = {
        list: {
          page: this.current_page,
          per_page: this.per_page,
          search: this.search,
          sortby: this.sortBy,
          sortbydesc: this.sortByDesc ? 'DESC' : 'ASC',
          is_active: this.is_active,
          checkin_status: this.checkin_status,
          ikid_class_name: this.ikid_class_name,
          kid_class_id: this.kid_class_id,
        },
        summaryFilter: this.$route.query.Pud || null,
      }
      if (useEventGuard) {
        payload.if_modified_since_event_id = this.lastEventId
      }

      await ikid.getKidsCheckManual(payload)
        .then(res => {
          if (res.not_changed) {
            this.lastEventId = res.event_id || this.lastEventId
            return
          }

          this.lastEventId = res.event_id || this.lastEventId
          const summary = res.summary || {}
          const list = res.list || {}

          this.datas = { data: summary.data || [] }
          this.listclass = summary.data || []
          this.items = list.data || []

          this.meta = {
            total: list.total || 0,
            current_page: list.current_page || this.current_page,
            per_page: list.per_page || this.per_page,
            from: list.from || 0,
            to: list.to || 0,
            is_active: this.is_active,
            checkin_status: this.checkin_status,
            ikid_class_name: this.ikid_class_name,
            kid_class_id: this.kid_class_id,
          }
        }).catch((err) => {
          var params = { title: 'Error', mode: 'danger', data: err.response && err.response.data ? err.response.data.message : 'Failed to load iKids manual data' }
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        })
    },
    queueRealtimeRefresh() {
      this.refreshQueued = true
      this.flushRealtimeRefresh()
    },
    flushRealtimeRefresh() {
      if (!this.refreshQueued || this.refreshInFlight || this.refreshTimer) return
      const elapsed = Date.now() - this.refreshLastRunAt
      const waitMs = Math.max(0, this.refreshIntervalMs - elapsed)

      this.refreshTimer = setTimeout(async () => {
        this.refreshTimer = null
        if (!this.refreshQueued || this.refreshInFlight) return
        this.refreshQueued = false
        this.refreshInFlight = true
        this.refreshLastRunAt = Date.now()
        try {
          await this.refreshData()
        } finally {
          this.refreshInFlight = false
          if (this.refreshQueued) this.flushRealtimeRefresh()
        }
      }, waitMs)
    },
    handlePerPage(val) {
      this.per_page = val
      this.current_page = 1
      this.refreshData()
    },
    handlePagination(val) {
      this.current_page = val
      this.refreshData()
    },
    handleSearch(val) {
      this.search = val
      this.current_page = 1
      this.refreshData({ useEventGuard: false })
    },
    handleSort(val) {
      this.sortBy = val.sortBy
      this.sortByDesc = val.sortDesc
      this.refreshData()
    },
    handleIsActive(val) {
      this.is_active = val
      this.refreshData()
    },
    handleStatus(val) {
      this.checkin_status = val
      this.current_page = 1
      this.refreshData()
    },
    handleClassFilter(val) {
      this.ikid_class_name = val
      this.current_page = 1
      this.refreshData()
    },
    handleCheckin(val) {
      this.openCheckin(val)
    },
    handlePresent(val) {
      this.openPresent(val)
    },
    handleCheckOut(val) {
      this.openCheckOut(val)
    },
    handleForceCheckOut(val) {
      this.openForceCheckOut(val)
    },
    handleCancelStatus(val, stat) {
      this.openCancelStatus(val, stat)
    },
    handleForceCancelStatus(val, stat) {
      this.openForceCancelStatus(val, stat)
    },
    handleReprint(val) {
      this.reprint(val)
    },
  }
}
</script>

<style>
.table_ikid_report {
  width: 100%;
  margin-bottom: 1rem;
  color: #212529;
}
.table_ikid_report th:nth-child(1),
.table_ikid_report td:nth-child(1),
.table_ikid_report th:nth-child(4),
.table_ikid_report td:nth-child(4) {
  border-right: 1px solid black;
}
</style>
